import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { ArrowLeft, Info } from "lucide-react";
import type { ComponentPropsWithoutRef } from "react";

interface MunPageContainerProps extends ComponentPropsWithoutRef<"div"> {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  tip?: string;
  onBack?: () => void;
}

export function MunPageContainer({
  children,
  title,
  subtitle,
  tip,
  onBack,
  className,
  ...props
}: MunPageContainerProps) {
  return (
    <div
      className={cn("space-y-6 animate-fade-in p-6 py-4", className)}
      {...props}
    >
      <div>
        {(title || onBack) && (
          <div className="flex items-center gap-4">
            {onBack && (
              <button
                type="button"
                onClick={onBack}
                className="shrink-0 -ml-2 h-10 w-10 p-0 rounded-md hover:bg-accent hover:text-accent-foreground transition-colors flex items-center justify-center"
              >
                <ArrowLeft className="h-6 w-6" />
              </button>
            )}
            <div className="flex-1">
        {title && (
                <div className="flex items-center gap-2">
          <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
                  {tip && (
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <button
                            type="button"
                            className="text-muted-foreground hover:text-foreground transition-colors"
                            aria-label="Show tip"
                          >
                            <Info className="h-5 w-5" />
                          </button>
                        </TooltipTrigger>
                        <TooltipContent
                          side="right"
                          align="start"
                          className="max-w-sm p-4 text-sm bg-popover text-popover-foreground border shadow-lg"
                        >
                          <p className="leading-relaxed whitespace-normal">{tip}</p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  )}
                </div>
        )}
        {subtitle && <p className="text-muted-foreground mt-1">{subtitle}</p>}
            </div>
          </div>
        )}
      </div>
      {children}
    </div>
  );
}
